import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from 'sonner';

import Landing from './pages/Landing';
import Home from './pages/Home';
import Trending from './pages/Trending';
import Notifications from './pages/Notifications';
import Submit from './pages/Submit';
import Profile from './pages/Profile';
import Payment from './pages/Payment';
import AdminDashboard from './pages/AdminDashboard';
import SuperAdminDashboard from './pages/SuperAdminDashboard';
import PublicProfile from './pages/PublicProfile';
import ResetPassword from './pages/ResetPassword';
import ForgotPassword from './pages/ForgotPassword';
import PostPage from './pages/PostPage';
import ControlPanel from './pages/ControlPanel';

import PrivateRoute from './components/PrivateRoute';
import RoleRoute from './components/RoleRoute';
import AnnouncementBanner from './components/AnnouncementBanner';
import AnnouncementPopup from './components/AnnouncementPopup';
import MaintenanceScreen from './components/MaintenanceScreen';

import { useAppConfig } from './context/AppConfigContext';
import { useAuth } from './context/AuthContext';

import '@/App.css';

function AppInner() {
  const { config, loaded, showBanner } = useAppConfig();
  const { user } = useAuth();

  const isAdmin = user?.role === 'admin' || user?.role === 'super_admin';

  // Show maintenance screen to non-admins only
  if (loaded && config.maintenance_mode && !isAdmin) {
    return <MaintenanceScreen />;
  }

  return (
    <>
      {/* Banner sits above navbar — fixed position so no layout shift on Routes */}
      <AnnouncementBanner />

      <Routes>
        {/* 🌍 Public */}
        <Route path="/" element={<Landing />} />
        <Route path="/trending" element={<Trending />} />
        <Route path="/profile/:username" element={<PublicProfile />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />

        {/* 🔒 Auth-required */}
        <Route path="/home" element={<PrivateRoute><Home /></PrivateRoute>} />
        <Route path="/notifications" element={<PrivateRoute><Notifications /></PrivateRoute>} />
        <Route path="/submit" element={<PrivateRoute><Submit /></PrivateRoute>} />
        <Route path="/profile" element={<PrivateRoute><Profile /></PrivateRoute>} />
        <Route path="/payment" element={<PrivateRoute><Payment /></PrivateRoute>} />
        <Route path="/post/:postId" element={<PrivateRoute><PostPage /></PrivateRoute>} />

        {/* 🔐 Role-restricted */}
        <Route path="/admin" element={
          <RoleRoute allowedRoles={['admin', 'super_admin']}>
            <AdminDashboard />
          </RoleRoute>
        } />
        <Route path="/super-admin" element={
          <RoleRoute allowedRoles={['super_admin']}>
            <SuperAdminDashboard />
          </RoleRoute>
        } />
        <Route path="/control-panel" element={
          <RoleRoute allowedRoles={['super_admin']}>
            <ControlPanel />
          </RoleRoute>
        } />
      </Routes>

      {/* Popup renders on top of all routes */}
      <AnnouncementPopup />
      <Toaster position="top-right" richColors />
    </>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AppInner />
    </BrowserRouter>
  );
}

export default App;